import styled from "styled-components";
import {
	DESKTOP_SM_BP,
	COLOR_TEXT_PRIMARY_B2C,
	COLOR_WHITE,
	COLOR_LIGHT_GREY,
	FONT_WT_REGULAR,
} from "@website-builder/utilities-index";

export const SecondaryNavWrapper = styled.div`
	margin-top: ${(props) => (props.sticky ? "120px" : "0")};

	.stickyWrapper {
		padding: 35px;
		background: ${COLOR_WHITE};
		display: flex;
		align-items: center;
		${(props) =>
			props.sticky
				? `position: fixed; top: 0; left: 0; right: 0;z-index: 100;padding: 15px 35px;border-bottom: 1px solid ${COLOR_LIGHT_GREY};`
				: ""}
		.linksWrapper {
			display: flex;
			align-items: center;
			flex-wrap: wrap;
			padding-left: 200px;
			a {
				color: ${COLOR_TEXT_PRIMARY_B2C};
				text-decoration: none;
				font-weight: ${FONT_WT_REGULAR};
				margin-right: 25px;
				font-size: 18px;
				line-height: 35px;
				cursor: pointer;
			}
			a:hover {
				color: #4f8ab0;
			}
		}
		.ctaWrapper {
			margin-left: auto;
			min-width: 400px;
			display: flex;
			justify-content: flex-end;
			column-gap: 16px;
			button {
				font-weight: 400;
			}
		}
	}
	@media only screen and (max-width: ${DESKTOP_SM_BP}px) {
		display: none;
	}
`;
